import { Component, OnInit, Inject, QueryList, ViewChildren, Output, EventEmitter } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LoaderService } from '@app/core/services/loader/loader.service';
import { StoreService } from '@app/feature/store-admin/services/store.service';
import { NotificationService } from '@app/core/services/notification/notification.service';

import { Router } from '@angular/router';
import { ErrorhandlerService } from '@app/shared/services/errorhandler/errorhandler.service';
import { ProductService } from '@app/shared/services/product/product.service';

import { HttpClient } from '@angular/common/http';
import { InksofteditorInterfaceData } from '../../inksofteditor/inksofteditor.interface';
import { StateService } from '@app/shared/services/state/state.service';
@Component({
  selector: 'app-design-list',
  templateUrl: './design-list.component.html',
  styleUrls: ['./design-list.component.css']
})
export class DesignListComponent implements OnInit {


  @ViewChildren('publishCheckbox') private publishCheckboxes !: QueryList<any>;
  selectedStores: any[] = [];
  pageSize = 1000;
  designList: any[] = [];
  searchText: string = '';
  searchClicked:boolean = false;
  constructor(public dialogRef: MatDialogRef<DesignListComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private loaderService: LoaderService, private storeService: StoreService, private notificationService: NotificationService,
    private router: Router, private errorhandlerService: ErrorhandlerService,
    private productService: ProductService, private http: HttpClient,
    private stateService: StateService) {

  }

  ngOnInit() {
    this.initialize();
  }

  initialize() {
    this.loaderService.show();
    var payload = {
      Skip: 0,
      Take: this.pageSize,
      SearchText: this.searchText.trim()
    }
    this.productService.getDesignList(payload).subscribe((res: any) => {
      this.loaderService.hide();
      if (res.Message === 'Success' || res.StatusCode === 200) {
        this.designList = res.Data.ResponseData        
      }
    })
  }
  searchDesign() {
    if(this.searchText.trim().length > 2){
      this.searchClicked = true;
    this.initialize()
    }
  }
  removeSearch(){
    this.searchClicked =false
    this.searchText = '';
    this.initialize();
  }
  onclose(): void {
    this.dialogRef.close();
  }

  openDesignStudio(designId): void {
    const data: InksofteditorInterfaceData = {
      productId: this.data.productId,
      categoryId: null,
      designId: designId,
      styleId: this.data.styleId,
      additionalInfo: this.data.productAdditionalInfo,
      sizingLabelExist: false,
      sizes: this.data.sizes
    };
    this.dialogRef.close(data);

    if (localStorage.getItem('role') === 'StoreAdmin') {
      //to make it run via store admin
      this.stateService.updateSelectedProduct(data);
      this.router.navigate(['/store/addproduct']);
    }
  }
}
